import { T, useTheme, dens, Ico, Card, Eyebrow, Btn } from '../../../design';
import type { SalonEnrollment } from '../../../types/courses.types';
import { fmtDate, fmtPrice } from '../../../utils';
import { EmptyState } from './states';

export interface ApprovalQueueProps {
  pending: SalonEnrollment[];
  onApprove: (e: SalonEnrollment) => void;
  onReject: (e: SalonEnrollment) => void;
}

export function ApprovalQueue({ pending, onApprove, onReject }: ApprovalQueueProps) {
  const t = useTheme();
  const d = dens(t);
  if (pending.length === 0) return <EmptyState icon="checkCircle" title="Alt er behandlet" sub="Ingen tilmeldinger afventer godkendelse lige nu." />;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: d.gap }}>
      <Eyebrow>Afventer godkendelse · {pending.length}</Eyebrow>
      {pending.map((e) => (
        <Card key={e.id} pad={14}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
            <span style={{ width: 40, height: 40, borderRadius: 999, background: T.accentLight, color: t.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 14, flexShrink: 0 }}>{e.employeeName.split(' ').map((s) => s[0]).slice(0, 2).join('')}</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: T.fg }}>{e.employeeName}</div>
              <div style={{ fontSize: 12, color: T.fg3, fontWeight: 600, marginTop: 2 }}>{e.courseProductName} · {fmtDate(e.courseDate)} · {fmtPrice(e.coursePrice)}</div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 9, marginTop: 12 }}>
            <Btn variant="secondary" size="sm" onClick={() => onReject(e)} style={{ flex: 1, color: T.error, borderColor: T.errorBorder }} icon={<Ico.x size={16} />}>Afvis</Btn>
            <Btn size="sm" onClick={() => onApprove(e)} style={{ flex: 1 }} icon={<Ico.check size={16} />}>Godkend</Btn>
          </div>
        </Card>
      ))}
    </div>
  );
}
